<template>
	<el-dialog title="提示" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
		<div class="content">
			<div class="flex">
				<i class="el-icon-warning mt-4"></i>
				<div class="text">以下商品正在与该达人合作，当前合作进度结束后才能继续合作！</div>
			</div>
			<el-table class="mt-16" :max-height="400" :data="list" header-row-class-name="table-header-row" row-class-name="table-row">
				<el-table-column label="商品信息" min-width="200">
					<template v-slot="{ row }">
						<div class="product">
							<el-image :src="row.product_pic" />
							<div class="ml-8">
								<div class="flex flex-align-center">
									<platform-icon :platformId="row.platform_id"></platform-icon>
									<div class="ml-4 ellipsis yx-color-text-primary" style="max-width: 120px">{{ row.product_name }}</div>
								</div>
								<div class="fz-12 yx-color-text-regular">商品ID: {{ row.product_id }}</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="partner_name" label="达人商务" min-width="100"></el-table-column>
				<el-table-column prop="cooperate_status_desc" label="合作阶段" min-width="100"></el-table-column>
			</el-table>
		</div>
		<span slot="footer">
			<el-button type="primary" @click="handleClose">我知道了</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'batchHintDialog',
	components: {},
	data() {
		return {
			list: [],
			dialogVisible: false,
		};
	},
	methods: {
		show(list) {
			this.list = list;
			this.dialogVisible = true;
		},
		handleClose() {
			this.list = [];
			this.dialogVisible = false;
		},
	},
};
</script>

<style lang="less" scoped>
.content {
	padding: 8px;
	.el-icon-warning {
		color: rgb(250, 143, 20);
		font-size: 16px;
	}
	.text {
		color: #333;
		font-size: 14px;
		line-height: 24px;
		margin-left: 6px;
	}
	.product {
		display: flex;
		.el-image {
			width: 40px;
			height: 40px;
			flex-shrink: 0;
		}
	}
}
</style>
